import { pxToRem } from '@mos-cat/ds-theme';
import { createComponent, createHook } from 'reakit-system';
import { BoxHTMLProps, BoxOptions, useBox } from '../../Box/Box';

export const useProgressBarWrapper = createHook<BoxOptions, BoxHTMLProps>({
  name: 'ProgressBarWrapper',
  compose: [useBox],

  useOptions(
    /* eslint-disable @typescript-eslint/no-unused-vars -- Следующие переменные исключены, поскольку стили внутри предназначены для защиты от изменений извне */
    {
      border,
      bg,
      backgroundColor,
      borderRadius,
      height,
      padding,
      paddingLeft,
      paddingRight,
      paddingBottom,
      paddingTop,
      paddingX,
      paddingY,
      px,
      py,
      p,
      pb,
      pl,
      pr,
      pt,
      ...options
    } /* eslint-enable @typescript-eslint/no-unused-vars -- продолжаем проверять */
  ) {
    return {
      ...options,
      border: '1',
      borderColor: 'transparent',
      bg: 'progressBarBg',
      borderRadius: pxToRem(8),
      width: '100%',
      styles: {
        backgroundClip: 'padding-box',
      },
    };
  },
});

export const ProgressBarWrapper = createComponent({
  as: 'div',
  useHook: useProgressBarWrapper,
  memo: true,
});
